import React, { useEffect } from 'react';
import { clearLastPath, getParameterByName } from '@shared/utils/UrlUtils';
import AuthWrapper from '../auth/components/AuthWrapper';
import { authentication } from "@microsoft/teams-js";

export default function LoginWithAdminConsentEnd() {
  useEffect(() => {
    document.body.style.backgroundColor = '#FAFAFA';
    clearLastPath();
  }, []);

  useEffect(() => {
    if (!authentication) {
      window.close();
      return;
    }

    const adminConsent = getParameterByName('admin_consent', window.location.href);
    const tenant = getParameterByName('tenant', window.location.href);
    const error = getParameterByName('error', window.location.href);
    const errorDescription = getParameterByName('error_description', window.location.href);
    const state = getParameterByName('state', window.location.href);
    const expectedState = localStorage.getItem('adminConsent.state');
    localStorage.removeItem('adminConsent.state');

    if (state && expectedState && state !== expectedState) {
      authentication.notifyFailure('AdminConsentStateMismatch');
      return;
    }

    if (error) {
      authentication.notifyFailure(`${error}: ${errorDescription ?? ''}`);
      return;
    }

    if (adminConsent === 'True' || adminConsent === 'true') {
      authentication.notifySuccess(JSON.stringify({ adminConsent: true, tenant }));
      return;
    }

    authentication.notifyFailure('AdminConsentNoResult');
  }, []);

  return (
    <AuthWrapper dataTest="admin-consent-end" title="" spinner={true} hideLoginLink={true} hideHeader={true}>
    </AuthWrapper>
  );
}
